import { useCallback } from 'react';
import type { AttachmentInput } from 'sr-types/lib/attachment/v1/graphql';
import type { EntityName } from '../../auth/Security';
import { FETCH_POLICY_CONFIG } from '../../constants/constants';
import { useMutationWithContext } from '../../hooks/useMutationWithContext';
import { client } from '../attachmentsApi';
import { DeleteAttachmentMutationError, DeleteAttachmentServerError } from '../constants';
import { deleteAttachmentsMutation } from './attachmentGraphqlApi';

export const useDeleteAttachments = () => {
    const [deleteMutation, { loading: isDeleting }] = useMutationWithContext(deleteAttachmentsMutation, client);

    const deleteAttachment = useCallback(
        async (entityName: EntityName, entityId: string, input: AttachmentInput) => {
            const result = await deleteMutation({
                variables: {
                    entityId,
                    entityType: entityName,
                    input: [input]
                },
                fetchPolicy: FETCH_POLICY_CONFIG.apolloFetchPolicy,
                errorPolicy: 'all'
            });

            if (result.errors?.length) {
                throw new DeleteAttachmentMutationError(result.errors[0].message);
            }

            if (result.data?.deleteAttachments?.errors?.length) {
                const error = result.data.deleteAttachments.errors[0];
                throw new DeleteAttachmentServerError(error?.message ?? error?.key);
            }

            return result;
        },
        [deleteMutation]
    );

    return { deleteAttachment, isDeleting };
};
